export default {"src":"/_next/static/media/supercell_id.cf864029.svg","height":46,"width":212};